/**
 * @description Component-TradeForm
 */
import './index.less';

import React, { FC, useEffect } from 'react';

import { TabType } from '@/constants';
import { EARN_TYPE } from '@/constants/earn';
import { useEarnFormType, useIsInWhiteList } from '@/features/earn/hook';
import { useCombinedPairFromUrl } from '@/features/pair/hook';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import DepositNativeCard from '@/pages/components/Portfolio/Vault/AccountButtons/Deposit/DepositModal/DepositNativeCard';

import { PAIR_PAGE_TYPE } from '@/constants/global';
import { useLocation, useNavigate } from 'react-router-dom';
import AddLiqForm from './AddLiqForm';
import PairNotInWhitelist from './PairNotInWhitelist';
import RemoveLiqForm from './RemoveLiqForm';

interface IPropTypes {
  children?: React.ReactNode;
  onClose?: () => void;
  isRemove?: boolean;
}
const EarnForm: FC<IPropTypes> = function ({ onClose, isRemove }) {
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const earnType = useEarnFormType(chainId);

  const currentPair = useCombinedPairFromUrl(chainId);
  const isInWhiteList = useIsInWhiteList(chainId, userAddr, currentPair?.rootInstrument.quoteToken);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log(`EarnForm mount`, location.pathname);
    if (location.pathname) {
      const newPath = location.pathname.replace(`/${PAIR_PAGE_TYPE.TRADE}`, `/${PAIR_PAGE_TYPE.EARN}`);
      navigate(newPath);
    }
    return () => {
      console.log(`EarnForm unmount`, location.pathname);
      if (location.pathname) {
        const newPath = location.pathname.replace(`/${PAIR_PAGE_TYPE.EARN}`, `/${PAIR_PAGE_TYPE.TRADE}`);
        navigate(newPath);
      }
    };
  }, []);

  return (
    <>
      {!isInWhiteList && earnType !== EARN_TYPE.REMOVE_LIQ ? (
        <PairNotInWhitelist currentPair={currentPair} />
      ) : (
        (earnType === EARN_TYPE.ADD_LIQ || earnType === EARN_TYPE.REMOVE_LIQ) && (
          <div className="syn-earn-form">
            {isRemove ? (
              <RemoveLiqForm onClose={onClose} />
            ) : (
              <>
                {earnType === EARN_TYPE.ADD_LIQ && <AddLiqForm onClose={onClose} />}
                {earnType === EARN_TYPE.REMOVE_LIQ && <RemoveLiqForm onClose={onClose} />}
              </>
            )}
          </div>
        )
      )}
      {earnType === EARN_TYPE.DEPOSIT_NATIVE && <DepositNativeCard location={TabType.Earn} />}
    </>
  );
};

export default EarnForm;
